export const checkIfDesktop = (width: number) => {
	return window.innerWidth >= width;
};
